<template>
<div class="chapter">
<div class="inner_page">
<p class="chtitle"><a id="page_25"><b>Counting Swallows</b></a></p><a id="page_25">
<p class="chauthor">MORGAN GRAYCE WILLOW</p>
<p class="poem">Flight patterns</p>
<p class="poem">above this intersection</p>
<p class="poem">where two cities meet,</p>
<p class="poem">announce that mosquitoes</p>
<p class="poem">have hatched this mid-May day.</p>
<p class="poem">There might be three,</p>
<p class="poem">or maybe a dozen swallows,</p>
<p class="poem">crossing the window frame</p>
<p class="poem">though never all at once,</p>
<p class="poem">and never simply left to right.</p>
<p class="poem">Instead their ellipses flatten,</p>
<p class="poem">loop, elongate into infinity signs,</p>
<p class="poem">a calligraphy of hunger</p>
<p class="poem">against pale blue.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Chapter02.vue?8171c9ba